module.exports = __webpack_public_path__ + "media/images/photo/features/unlimited_data-c6c469488a3e13b44ec0026ce1af6bc5.svg";